module.exports = __webpack_public_path__ + "static/media/teamx.79caba09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Hero/teamx.jpg
// module id = 393
// module chunks = 0